import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Check(props) {
    return (
        <SvgIcon {...props}>
            <circle cx="8" cy="8" r="8" fill="#5ec398" />
            <path
                d="M7.1 9.08c.03-.05.07-.1.1-.15.43-.63.86-1.27 1.29-1.9.36-.54.73-1.08 1.09-1.61.07-.11.14-.22.21-.32.05-.06.1-.12.18-.15.1-.04.2-.01.29.05.15.09.29.19.43.29.04.03.07.05.11.07.18.14.21.31.08.49-.5.74-1 1.47-1.49 2.2-.54.8-1.09 1.6-1.63 2.4-.05.08-.11.16-.17.23-.07.09-.16.14-.28.16a.483.483 0 0 1-.35-.08c-.1-.06-.18-.15-.27-.23L4.98 8.82a.586.586 0 0 1-.13-.19c-.04-.11-.01-.21.06-.3.03-.04.06-.07.09-.11l.36-.36c.05-.05.1-.09.17-.12.13-.05.24 0 .34.09.15.14.29.29.43.43.24.24.48.48.72.71.02.04.05.07.08.11z"
                fill="#fff"
            />
        </SvgIcon>
    );
}

Check.defaultProps = {
    viewBox: '0 0 16 16'
};

export default Check;
